// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n3-c";
export var backButton = "_n3-4";
export var backIcon = "_n3-5";
export var chevronShortcut = "_n3-6";
export var container = "_n3-1";
export var editor = "_n3-8";
export var editorWrapper = "_n3-7";
export var prefix = "_n3-2";
export var searchIcon = "_n3-3";
export var suffix = "_n3-9";
export var suffixContent = "_n3-a";
export var suffixText = "_n3-b";
export var wrapper = "_n3-0";